// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});
	
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		
		/* Initialize Parallax Lybrary */
		let istouch = document.querySelector('.mod-no-touchevents')
		if( $(window).width() > 767 ){
			if(istouch){
				var sk = skrollr.init();
			}
		}

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		var btns = document.querySelectorAll('.btn');
		if(btns){
			btns.forEach( ebtn =>{
				if( ! ebtn.querySelector('span') ){
					ebtn.appendChild(document.createElement('span'));
				}
				if( ! ebtn.classList.contains('.attractions-map__expand') ){
					ebtn.addEventListener('click', eve =>{
						var targ = ebtn.getAttribute('href');
						if(targ.startsWith('#') && targ != '#' && !ebtn.hasAttribute('data-fancybox') ){
							var allsb = document.querySelectorAll(targ);
							if(allsb.length > 0 ){
								eve.preventDefault();
								$('html, body').animate({
									scrollTop: $(targ).offset().top - $('#header').height() - 20
								}, 700, 'swing', function () {});
							}
						}	
					});
				}
			});
		} 
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

var btns = document.querySelectorAll('.btn');
if(btns){
	btns.forEach( ebtn =>{
		if( ! ebtn.querySelector('span') ){
			ebtn.appendChild(document.createElement('span'));
		}
	})
}

//Make subnav scroll to content when it is available. 
const scrolltobtns = document.querySelectorAll('.scrollto');
if(scrolltobtns){
	scrolltobtns.forEach(el =>{
		el.addEventListener('click',(ev)=>{
			let hrefUrl = el.getAttribute("href");
			if(hrefUrl.includes('#')){
				let selectorString = '#' + hrefUrl.split('#')[1]; 
				if( document.querySelector(selectorString) ){
					ev.preventDefault();
					$('html, body').animate({
						scrollTop: $(selectorString).offset().top - $('#header').height() - 20
					}, 700, 'swing', function () {});
				}
			}
		});
	});
}

$('.reasons__arrow-prev').click(function(e){
	e.preventDefault();
	$(this).closest('.sym-slides').slick('slickPrev');
});
$('.reasons__arrow-next').click(function(e){
	e.preventDefault();
	$(this).closest('.sym-slides').slick('slickNext');
});
const toletterize = document.querySelectorAll('.letterizr');
if(toletterize){
	toletterize.forEach( ele=>{
		let	letters = ele.innerHTML.trim().split('');
		let htmlString = '';
		let counti = 0;
		letters.forEach( letter =>{
			htmlString += `<span class="delay-${counti}">${letter}</span>`;
			counti++;
		});
		ele.innerHTML = htmlString;
	});
}

var bookbtn = document.querySelector('.header__booking_btn');
if(bookbtn){
	var initlabel = bookbtn.innerHTML;
	bookbtn.addEventListener('click', function (e) {
		e.preventDefault();
		var menuObj = document.querySelector('.header__hold');
		if( menuObj.classList.contains('bookingOpen') ){
			menuObj.classList.remove('bookingOpen');
			bookbtn.innerHTML = initlabel;
		}else{
			menuObj.classList.add('bookingOpen');
			bookbtn.innerHTML = "Close<span></span>";
		}
	});
}

var overlaytabs = document.querySelectorAll('.booking-tabs a');
if(overlaytabs){
	overlaytabs.forEach(ele=>{
		ele.addEventListener('click',(e)=>{
			e.preventDefault();
			if( ! ele.classList.contains('active')){
				overlaytabs.forEach(elem=>{ elem.classList.remove('active')});
				ele.classList.add('active');
				var targ = ele.getAttribute('href');
				document.querySelectorAll('.panels > div').forEach(ele=>{
					ele.classList.add('hide');
				});
				console.log(document.querySelector(targ));
				document.querySelector(targ).classList.remove('hide');
			}
		});
	});
}

/* Accordion */
var accordionItems = document.querySelectorAll('.accordion__item');
var i;
for (i = 0; i < accordionItems.length; i++) {
	let disItem = accordionItems[i];
	let disBtn = disItem.querySelector('.accordion__btn');
	disBtn.addEventListener('click', function(){
		disItem.classList.toggle('open');
	});
}


/* Vendors Menu */
var vendorsBtns = document.querySelectorAll('.menuvendors_cat-title');
var allVendors = document.querySelectorAll('.menuvendors_cat-hold');
if(vendorsBtns){
	vendorsBtns.forEach(vendorBtn=>{
		vendorBtn.addEventListener('click', ()=>{
			var disVendor = vendorBtn.parentElement;
			if(disVendor.classList.contains('open')){
				disVendor.classList.remove('open');
			}else{
				disVendor.classList.add('open');
			}
		});
	});
}
var allProds = document.querySelectorAll('.menuvendors_prod-name');
if(allProds){
	allProds.forEach(prodBtn=>{
		prodBtn.addEventListener('click', ()=>{
			var disProd = prodBtn.parentElement;
			if(disProd.classList.contains('open-prod')){
				disProd.classList.remove('open-prod');
			}else{
				disProd.classList.add('open-prod');
			}
		});
	});
}

var hambbtn = document.querySelector('.hamburger__btn');
if(hambbtn){
	hambbtn.addEventListener('click', function () {
		var menuObj = document.querySelector('.header');
		var bottomnav = document.querySelector('nav.buttons');
		if( menuObj.classList.contains('open-nav') ){
			menuObj.classList.remove('open-nav');
			bottomnav.classList.remove('open-nav');
		}else{
			menuObj.classList.add('open-nav');
			bottomnav.classList.add('open-nav');
		}
	});
}